import dayjs from "dayjs";

export function formatDate(dateToFormat?: string | null) {
  return dateToFormat ? dayjs(dateToFormat).format("DD MMM YYYY") : "Unknown";
}
